// extracted by mini-css-extract-plugin
module.exports = {"headline":"Filter-module__headline___FkJjK","list":"Filter-module__list___3xRfd","loading":"Filter-module__loading___2aK5m"};